export const ROOT_TREE_INJECTION_KEY = 'RootTree'

export const NODE_INSTANCE_INJECTION_KEY = 'NodeInstance'

export const TREE_NODE_MAP_INJECTION_KEY = 'TreeNodeMap'
